import styles from "./RequiredAsterisk.module.css";

const RequiredAsterisk = () => {
  return <span className={styles.asterisk}>*</span>;
};

export default RequiredAsterisk;
